<template>
    <video src="../assets/video.mp4" controls>
</video>
</template>

<script>
    export default {
        name: "Video"
    }
</script>

<style scoped>

</style>